import React, { Component } from 'react';
import { Collapse, message, Modal, Button } from 'antd';
import { map, orderBy } from 'lodash';

import Sidebar from './Sidebar';
import * as yup from 'yup';

// Images
import building from '../../../Assets/images/buildings.svg';
import house from '../../../Assets/images/house.svg';
import garden from '../../../Assets/images/garden.svg';

import pup1 from '../../../Assets/images/1_pup.svg';
import pup2 from '../../../Assets/images/2_pup.svg';
import pup3 from '../../../Assets/images/3_pup.svg';
import pup4 from '../../../Assets/images/4_pup.svg';
import Path from '../../../Assets/images/Path.svg';
import {errorHandle} from "../../Common/errorHandle";

const { Panel } = Collapse;

const OTHER_INDEX = 6;

class Step1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      extra_pet_count: '',
      areas_to_clean: [
        { display: 'Front Yard', value: 'front yard', isSelected: false, isFirst: false },
        { display: 'Back Yard', value: 'back yard', isSelected: false, isFirst: false },
        { display: 'Right Side', value: 'right side', isSelected: false, isFirst: false },
        { display: 'Left Side', value: 'left side', isSelected: false, isFirst: false },
        { display: 'Dog Run', value: 'dog run', isSelected: false, isFirst: false },
        { display: 'Fenced Area', value: 'fenced area', isSelected: false, isFirst: false },
        { display: 'Other', value: '', isSelected: false, isFirst: false },
      ],
      pricing_range: [],
      add_ons: [],
      ZipcodeCheck: [],
      step1: {},
      originalFrequency: '',
      // errors: {},
      loader: false,
      is_single_family_large: false,
      is_extra_pet: false,
      is_continue_btn_active: false,
      cleaning_notes: '',
      disposal_location: '',
      frequency: '',
      property_type: '',
      pet_count: '',
      last_cleaned: '',
      field_office_uuid: '',
      prepay_months: null,
      errors: {},
      selectedArea: []
    }
  }

  UNSAFE_componentWillMount = () => {
    const zipcode = JSON.parse(sessionStorage.getItem('area'));
    const step1 = JSON.parse(sessionStorage.getItem('step1'));
    window.scrollTo(0, 0);
    if (zipcode) {
      this.setState({
        field_office_uuid: zipcode['uuid']
      })
      if (this.props.history.location.state) {
        if (this.props.history.location.state.query.frequency_price) {
          this.setState({
            frequency: this.props.history.location.state.query.frequency_price.frequency,
            originalFrequency: this.props.history.location.state.query.frequency_price.frequency,
          })
        }
      }
    }
    else {
      this.props.history.push('/');
    }

    if (step1) {
      let api_data = {
        'is_prepaid': this.props.is_prepaid,
        'field_office_uuid': step1.field_office_uuid,
        'frequency': step1.frequency,
        'pet_count': step1.pet_count === "4" ? step1.extra_pet_count : step1.pet_count,
        'last_cleaned': step1.last_cleaned,
        'property_type': step1.property_type,
        'prepay_for_year': step1.prepay_for_year,
        'prepay_months': this.props.prepay_months,
        'add_ons': step1.add_ons,
        'areas_to_clean': step1.areas_to_clean,
        'coupon_code': step1.coupon_code && step1.coupon_code,
        zipcode: zipcode?.zipcode,
      }
      if (!step1.coupon_code) {
        delete api_data.coupon_code
      }
      this.props.pricingCalculator(api_data)

      const formattedAreas = [
        { display: 'Front Yard', value: 'front yard', isSelected: false, isFirst: false },
        { display: 'Back Yard', value: 'back yard', isSelected: false, isFirst: false },
        { display: 'Right Side', value: 'right side', isSelected: false, isFirst: false },
        { display: 'Left Side', value: 'left side', isSelected: false, isFirst: false },
        { display: 'Dog Run', value: 'dog run', isSelected: false, isFirst: false },
        { display: 'Fenced Area', value: 'fenced area', isSelected: false, isFirst: false },
        { display: 'Other', value: '', isSelected: false, isFirst: false },
      ];

      step1.areas_to_clean.forEach(x => {
        let indexToEdit = formattedAreas.findIndex(y => y.value === x);
        if (indexToEdit === -1) indexToEdit = 6;

        formattedAreas[indexToEdit].isSelected = true;
        if (!formattedAreas.some(x => x.isFirst)) formattedAreas[indexToEdit].isFirst = true;
        if (indexToEdit === 6) formattedAreas[indexToEdit].value = x;
      });

      this.setState({
        frequency: step1.frequency,
        property_type: step1.property_type,
        pet_count: step1.pet_count,
        last_cleaned: step1.last_cleaned,
        field_office_uuid: step1.field_office_uuid,
        extra_pet_count: step1.extra_pet_count,
        areas_to_clean: formattedAreas,
        add_ons: step1.add_ons && step1.add_ons,
        is_extra_pet: step1.is_extra_pet,
        is_continue_btn_active: true,
        selectedAreas: orderBy(formattedAreas, 'isFirst', 'desc').filter(x => x.isSelected)
      })
    }

    if (zipcode) {
      this.props.getPriceList(zipcode['uuid']);
    }

    if (zipcode && zipcode['zipcode']) {
      this.props.checkZipCode({ 'addressable_zip_codes__contains': zipcode['zipcode'] })
    }

  }

  UNSAFE_componentWillReceiveProps = (props) => {
    message.destroy();
    if (Object.keys(props.PricingCalc.data).length > 0 && props.PricingCalc.data !== this.props.PricingCalc.data) {
      this.setState({
        loader: false,
        is_continue_btn_active: true
      })

    }
    if (Object.keys(props.PricingCalc.errors).length > 0) {
      this.setState({
        loader: false
      })
      if (Object.keys(props.PricingCalc.errors).length > 0 && !props.PricingCalc.errors.coupon_code && props.PricingCalc.errors !== this.props.PricingCalc.errors) {
        errorHandle(props?.PricingCalc.errors)
      }
    }

    if (Object.keys(props.PriceList.data).length > 0) {
      this.setState({
        pricing_range: props.PriceList.data['pricing_range'],
      })
    }

    if (Object.keys(props.ZipcodeCheck.data).length > 0 && props.ZipcodeCheck.data !== this.props.ZipcodeCheck.data) {

      this.setState({
        ZipcodeCheck: props.ZipcodeCheck.data.results
      })
    }
  }

  // What’s your place Change
  onPropertyDataChange = (e) => {
    if (e.target.checked) {
      if (e.target.value === 'single_family_large') {
        this.setState({
          is_single_family_large: true,
          is_continue_btn_active: false
        })
        this.props.userCanProceedToCheckout(false);
      } else {
        this.setState({
          property_type: e.target.value,
        })
        delete this.state.errors.property_type
        this.getPriceMatrics();
      }
    }
  }
  // How many pups do you have
  petOnDataChange = (e) => {
    if (e.target.checked) {
      if (e.target.value === "4") {
        this.setState({
          is_extra_pet: true,
          is_continue_btn_active: false,
          pet_count: ''
        })
        this.props.userCanProceedToCheckout(false);
      } else {
        this.setState({
          pet_count: e.target.value,
          is_extra_pet: false,
          extra_pet_count: '',
          is_continue_btn_active: false
        })
        this.props.userCanProceedToCheckout(false);
        this.getPriceMatrics();
        delete this.state.errors.pet_count
      }
    }
  }

  // Single Value Select
  onLastCleanChange = (e) => {
    if (e.target.checked) {
      this.setState({
        last_cleaned: e.target.value,
      })
      delete this.state.errors.last_cleaned;
      this.getPriceMatrics();
    }
  }

  // Render Price List
  renderPriceList = () => {
    const { pricing_range, frequency, originalFrequency } = this.state;

    if (pricing_range.length === 0) return;
    const orderedPricingRange = [
      pricing_range.find(x => x.frequency === "twice_weekly"),
      pricing_range.find(x => x.frequency === "weekly"),
      pricing_range.find(x => x.frequency === "bi_monthly"),
      pricing_range.find(x => x.frequency === "monthly"),
      pricing_range.find(x => x.frequency === "once")
    ];

    if (originalFrequency !== "once") orderedPricingRange.pop()

    return map(orderedPricingRange, (item, i) => {
      return (
        <li key={i}>
          <label htmlFor={item.frequency}
            className={frequency === item.frequency ? 'area_box active_area_box' : frequency !== '' && frequency !== item.frequency ? 'area_box box_opacity' : 'area_box'}
            style={originalFrequency === "once" ? { paddingLeft: 15, paddingRight: 15 } : {}}
          >
            <input type="checkbox" checked={frequency === item.frequency} id={item.frequency} value={item.frequency}
              onChange={(e) => {
                if (e.target.checked) {
                  this.getPriceMatrics();
                  this.setState({
                    frequency: e.target.value,
                    frequency_price: { frequency: "bi_monthly", min_price: 12, max_price: 47 }
                  })
                  if (e.target.value === "once") {
                    this.props.onPrepayChange({}, true)
                  }
                }
              }} name={item.frequency} className="custom--checkbox" />
            <span>{item.frequency === 'bi_monthly' ? 'Every Other Week' : item.frequency === 'twice_weekly' ? 'Twice Weekly' : item.frequency === 'once' ? 'Just Once' : item.frequency}</span>
          </label>
        </li>
      )
    })
  }

  // Render Additional Services
  renderAdditionalServices = () => {
    const { ZipcodeCheck, add_ons } = this.state;
    if (ZipcodeCheck) {
      return map(orderBy(ZipcodeCheck[0]?.add_on, ['priority'], ['asc']), (item, i) => {
        const firstVisit = add_ons.filter(x => !x.is_recurring);
        const eachVisit = add_ons.filter(x => x.is_recurring)
        return (
          item.is_active ?
            <li className="option_list_item" key={i}>
              <div className="service_box">
                <div className="checkbox_wrapper">
                  <label>{item.name}</label>
                </div>
                <label className="service_price">{`${item.cost_per_visit > 0 ? `+$${item.cost_per_visit} per visit` : 'FREE'}`}</label>
                <div>
                  <label htmlFor={item.uuid}
                    className={firstVisit.some(x => x.uuid === item.uuid) ? 'btn btn-outline--primary added' : 'btn btn-outline--primary'}>
                    {firstVisit.some(x => x.uuid === item.uuid) ? 'Added!' : 'First Visit '}
                    <input type="checkbox" id={item.uuid}
                      onChange={(e) => { this.addAddOns(e, item, false) }}
                      checked={firstVisit.some(x => x.uuid === item.uuid) ? true : false}
                      value={item.name} name={item.name} className="custom--checkbox" />
                  </label>
                  <label htmlFor={item.name}
                    className={eachVisit.some(x => x.uuid === item.uuid) ? 'btn btn-outline--primary added' : 'btn btn-outline--primary'}>
                    {eachVisit.some(x => x.uuid === item.uuid) ? 'Added!' : 'Each Visit '}
                    <input type="checkbox" id={item.name}
                      onChange={(e) => { this.addAddOns(e, item, true) }}
                      checked={eachVisit.some(x => x.uuid === item.uuid) ? true : false}
                      value={item.name} name={item.name} className="custom--checkbox" />
                  </label>
                </div>
              </div>
            </li> : ''
        )
      })
    }
  }

  // Add Add Ons
  addAddOns = (e, item, type) => {
    const { add_ons } = this.state;
    const indexToRemove = add_ons.findIndex(x => x.uuid === item.uuid);
    if (indexToRemove > -1) {
      if (add_ons[indexToRemove]?.name === 'Take waste away') {
        this.setState({
          is_take_away: false,
          disposal_location: ''
        })
      }
      add_ons.splice(indexToRemove, 1);

    }


    if (e.target.checked) {
      add_ons.push({ "uuid": item.uuid, "is_recurring": type, 'name': item.name });
      if (item.name === 'Take waste away') {
        this.setState({
          is_take_away: true,
          disposal_location: ''
        })
      }
    }

    this.setState({
      add_ons,
      is_continue_btn_active: false
    })
    this.props.userCanProceedToCheckout(false);

    this.getPriceMatrics();

  }

  // Multi Value Select
  onAreaCleanChange = (area) => {
    const newAreas = [...this.state.areas_to_clean];
    const { areas_to_clean, selectedArea } = this.state;

    const index = areas_to_clean.findIndex(x => x.display === area.display);
    newAreas[index].isSelected = !areas_to_clean[index].isSelected;

    if (!areas_to_clean.some(x => x.isFirst)) {
      newAreas[index].isFirst = true;
    } else if (area.isFirst) {
      newAreas[index].isFirst = false;
      const indexToAssignFirst = newAreas.findIndex(x => !x.isFirst && x.isSelected)
      if (indexToAssignFirst !== -1) {
        newAreas[indexToAssignFirst].isFirst = true;
      }
    }

    // for selected area
    const idx = selectedArea.findIndex(x => x.display === area.display);
    if (idx === -1) {
      selectedArea.push(newAreas[index])
    } else {
      selectedArea.splice(idx, 1)
    }

    if (area.display === 'Other' && !area.value) {
      this.setState({ is_continue_btn_active: false })
    }

    this.setState({ areas_to_clean: newAreas, selectedArea }, () => this.getPriceMatrics())
  }

  //Call API Based on selection
  getPriceMatrics = () => {
    setTimeout(() => {
      let pets = 0;
      let step1 = JSON.parse(sessionStorage.getItem('step1'));
      const zipcode = JSON.parse(sessionStorage.getItem('area'));
      let coupon_code = step1 && step1.coupon_code && step1.coupon_code;
      const { is_extra_pet, cleaning_notes, disposal_location, field_office_uuid, frequency, pet_count, extra_pet_count, last_cleaned, property_type, prepay_for_year, areas_to_clean, add_ons } = this.state;
      if (pet_count === '' && is_extra_pet && extra_pet_count) {
        pets = extra_pet_count
      } else {
        pets = pet_count
      }

      let areasToSubmit = orderBy(areas_to_clean, 'isFirst', 'desc')
      areasToSubmit = areasToSubmit.filter(x => x.isSelected).map(y => y.value);

      if (pets && property_type && frequency && last_cleaned) {
        let api_data = {
          'is_prepaid': this.props.is_prepaid,
          'field_office_uuid': field_office_uuid,
          'frequency': frequency,
          'pet_count': pets,
          'last_cleaned': last_cleaned || null,
          'property_type': property_type,
          'prepay_for_year': prepay_for_year,
          'areas_to_clean': areasToSubmit,
          'add_ons': add_ons,
          'prepay_months': this.props.prepay_months,
          'coupon_code': coupon_code,
          zipcode: zipcode?.zipcode
        }


        if (frequency === 'once') {
          if (pets && property_type && frequency && last_cleaned) {
            this.props.pricingCalculator(api_data)
            if (!areas_to_clean[OTHER_INDEX].isSelected || (areas_to_clean[OTHER_INDEX].isSelected && areas_to_clean[OTHER_INDEX].value)) {
              this.setState({
                loader: true,
                is_continue_btn_active: true,
                errors: {}
              })
            }
            this.props.userCanProceedToCheckout(true);
            sessionStorage.setItem('step1', JSON.stringify({
              'extra_pet_count': extra_pet_count,
              'is_extra_pet': is_extra_pet,
              'field_office_uuid': field_office_uuid,
              'frequency': frequency,
              'pet_count': pets,
              'last_cleaned': last_cleaned,
              'property_type': property_type,
              'prepay_for_year': prepay_for_year,
              'areas_to_clean': areasToSubmit,
              'add_ons': add_ons,
              'cleaning_notes': cleaning_notes,
              'disposal_location': disposal_location,
              'coupon_code': coupon_code
            }));

          }
        }
        else {
          this.props.pricingCalculator(api_data)
          if (!areas_to_clean[OTHER_INDEX].isSelected || (areas_to_clean[OTHER_INDEX].isSelected && areas_to_clean[OTHER_INDEX].value)) {
            this.setState({
              loader: true,
              errors: {}
            })
          }
          this.props.userCanProceedToCheckout(true);
          sessionStorage.setItem('step1', JSON.stringify({
            'extra_pet_count': extra_pet_count,
            'is_extra_pet': is_extra_pet,
            'field_office_uuid': field_office_uuid,
            'frequency': frequency,
            'pet_count': pets,
            'last_cleaned': last_cleaned,
            'property_type': property_type,
            'prepay_for_year': prepay_for_year,
            'areas_to_clean': areasToSubmit,
            'add_ons': add_ons,
            'cleaning_notes': cleaning_notes,
            'disposal_location': disposal_location,
            'coupon_code': coupon_code
          }));

        }
      }
      else {
        this.setState({ is_continue_btn_active: false })
        this.props.userCanProceedToCheckout(false);
      }
    }, 400);
  }

  //Go to Next Step
  goToNextStep = () => {
    let pets = 0;
    let step1 = JSON.parse(sessionStorage.getItem('step1'));
    let coupon_code = step1 && step1.coupon_code && step1.coupon_code;
    const { 
      is_extra_pet,
      cleaning_notes,
      disposal_location,
      field_office_uuid,
      frequency,
      pet_count,
      extra_pet_count,
      last_cleaned,
      property_type,
      prepay_for_year,
      areas_to_clean,
      add_ons
    } = this.state;

    this.props.updateCustomerLastCompletedStep({
      step: 3,
      tracking_uuid: JSON.parse(sessionStorage.getItem("tracking_uuid"))
    });

    if (pet_count === '' && is_extra_pet && extra_pet_count) {
      pets = extra_pet_count
    }
    else {
      if(is_extra_pet && !extra_pet_count)
      {
        this.setState({errors: {pet_count: 'Pet count is required'}});
        return;
      }
      else
        pets = pet_count;
    }

    if(areas_to_clean[OTHER_INDEX].isSelected && areas_to_clean[OTHER_INDEX].value === ''){
      areas_to_clean[OTHER_INDEX].value = 'Other';
    }
    
    const areasToSubmit = areas_to_clean.filter(x => x.isSelected).map(y => y.value);

    sessionStorage.setItem('step1', JSON.stringify({
      'extra_pet_count': extra_pet_count,
      'is_extra_pet': is_extra_pet,
      'field_office_uuid': field_office_uuid,
      'frequency': frequency,
      'pet_count': pets,
      'last_cleaned': last_cleaned,
      'property_type': property_type,
      'prepay_for_year': prepay_for_year,
      'areas_to_clean': areasToSubmit,
      'add_ons': add_ons,
      'cleaning_notes': cleaning_notes,
      'disposal_location': disposal_location,
      'coupon_code': coupon_code
    }))
    this.props.nextPage();

  }

  goBack(e) {
    this.props.clearPricingCalc()
    window.history.back(e)
  }

  getAreasToCleanText(text, isFirst, price, areas) {
    if (!areas.some(x => x.isFirst)) return text;
    if (isFirst) return text;
    return `+$${price} ${text}`;
  }

  //Setp 1 Validation With messages

  Setp1Validation = () => {
    let self = this;
    setTimeout(() => {

      let { property_type, pet_count, last_cleaned, frequency } = this.state;
      let Step1Schema = yup.object().shape({
        frequency: yup.string().required("Frequency is required"),
        property_type: yup.string().required("Property type is required"),
        pet_count: yup.string().required("Pet count is required"),
        last_cleaned: yup.string().when("frequency", { is: 'once', then: yup.string().required("Last cleaned  is required") }),
      })

      const Step1Data = { property_type, pet_count, last_cleaned, frequency };

      let IsValid;
      let err_data = {};
      Step1Schema.isValid(Step1Data)
        .then(function (valid) {
          IsValid = valid
        });
      setTimeout(() => {
        if (IsValid) {
          self.setState({
            errors: {}
          })
        }
        else {
          Step1Schema.validate(Step1Data, { abortEarly: false })
            .catch(function (err) {
              map(err.inner, (item) => {
                err_data[item.path] = item.message;
              })
              self.setState({
                errors: err_data
              })
              // console.log("err_data:", err_data)
            });
        }
      }, 100);
    })
  }

  render() {
    const {
      property_type,
      pet_count,
      last_cleaned,
      loader,
      areas_to_clean,
      ZipcodeCheck,
      is_extra_pet,
      extra_pet_count,
      is_continue_btn_active,
      frequency,
      is_single_family_large,
      is_take_away,
      errors
    } = this.state;

    const price = ZipcodeCheck.length > 0 ? ZipcodeCheck[0]['additional_cleaning_area_price'] : ''

    return (
      <div className="row">
        <div className="col-md-7 col-lg-7">
          <div className="quote_form">
            <label className="indicate_msg">* Sign Field Are Required</label>
            <label className="back_arrow cursor_pointer" onClick={(e) => this.goBack(e)}><i className="las la-arrow-left"></i>Back </label>
            <section className="frequency_type">
              <h3 className="mb-10">How often do you need your yard cleaned? <span className="required">*</span></h3>
              <ul>
                {this.renderPriceList()}
              </ul>
            </section>
            <Collapse
              defaultActiveKey={['1']}
              expandIconPosition="right"
              expandIcon={({ isActive }) => <img src={Path} alt="" className={isActive ? '' : 'icon_rotate'} />}
            >
              <Panel header="What’s your place like? " key="1" className="place_section required_collapse_header">
                <div className="option_list">
                  <div className="option_list_item">
                    <label htmlFor="townhouse" className={property_type === 'townhouse' ? 'place_box active_place_box' : property_type !== '' && property_type !== 'townhouse' ? 'place_box box_opacity' : 'place_box'}>
                      <span>Town House</span>
                      <img src={building} alt="" />
                      <input type="checkbox" checked={property_type === 'townhouse' ? true : false} id="townhouse" value="townhouse" name="townhouse" onChange={(e) => { this.onPropertyDataChange(e) }} className="custom--checkbox" />
                    </label>
                  </div>
                  <div className="option_list_item">
                    <label htmlFor="single_family_small" className={property_type === 'single_family_small' ? 'place_box active_place_box' : property_type !== '' && property_type !== 'single_family_small' ? 'place_box box_opacity' : 'place_box'}>
                      <span>Detached</span>
                      <p className="sub_details">(Less than 0.5 acre. lot)</p>
                      <img src={house} alt="" />
                      <input type="checkbox" id="single_family_small" value="single_family_small" name="single_family_small" checked={property_type === 'single_family_small' ? true : false} onChange={(e) => { this.onPropertyDataChange(e) }} className="custom--checkbox" />
                    </label>
                  </div>
                  <div className="option_list_item">
                    <label htmlFor="single_family_large" className={property_type === 'single_family_large' ? 'place_box active_place_box' : property_type !== '' && property_type !== 'single_family_large' ? 'place_box box_opacity' : 'place_box'}>
                      <span>Detached</span>
                      <p className="sub_details">(More than 0.5 acres. lot)</p>
                      <img src={garden} alt="" />
                      <input type="checkbox" id="single_family_large" checked={property_type === 'single_family_large' ? true : false} value="single_family_large" onChange={(e) => { this.onPropertyDataChange(e) }} name="single_family_large" className="custom--checkbox" />
                    </label>
                  </div>
                </div>
              </Panel>
            </Collapse>
            {errors?.property_type ? <label className="new_err_msg"><i className="las la-info-circle"></i> {errors?.property_type}</label> : ''}
            <Collapse
              defaultActiveKey={['2']}
              expandIconPosition="right"
              expandIcon={({ isActive }) => <img src={Path} alt="" className={isActive ? '' : 'icon_rotate'} />}
            >
              <Panel header="How many pups on the property?" key="2" className="pup_section">
                <div className="option_list">
                  <div className="option_list_item">
                    <label htmlFor="1"
                      className={pet_count === '1' ? 'place_box pup_box  active_place_box' : pet_count !== '' && pet_count !== '1' ? 'place_box pup_box  box_opacity' : 'place_box pup_box '}
                    >
                      <span>1</span>
                      <img src={pup1} className="single_pup" alt="" />
                      <input type="checkbox" checked={pet_count === '1' ? true : false} id="1" value="1" onChange={(e) => { this.petOnDataChange(e, 'pet_count') }} name="1" className="custom--checkbox" />
                    </label>
                  </div>
                  <div className="option_list_item">
                    <label htmlFor="2"
                      className={pet_count === '2' ? 'place_box pup_box  active_place_box' : pet_count !== '' && pet_count !== '2' ? 'place_box pup_box  box_opacity' : 'place_box pup_box '}
                    >
                      <span>2</span>
                      <img src={pup2} alt="" />
                      <input type="checkbox" checked={pet_count === '2' ? true : false} id="2" value="2" onChange={(e) => { this.petOnDataChange(e, 'pet_count') }} name="2" className="custom--checkbox" />
                    </label>
                  </div>
                  <div className="option_list_item">
                    <label htmlFor="3"
                      className={pet_count === '3' ? 'place_box pup_box  active_place_box' : pet_count !== '' && pet_count !== '3' ? 'place_box pup_box  box_opacity' : 'place_box pup_box '}
                    >
                      <span>3</span>
                      <img src={pup3} alt="" />
                      <input type="checkbox" checked={pet_count === '3' ? true : false} id="3" value="3" onChange={(e) => { this.petOnDataChange(e, 'pet_count') }} name="3" className="custom--checkbox" />
                    </label>
                  </div>
                  <div className="option_list_item">
                    <label htmlFor="4"
                      className={is_extra_pet ? 'place_box pup_box  active_place_box' : pet_count !== '' && pet_count !== '4' ? 'place_box pup_box  box_opacity' : 'place_box pup_box '}
                    >
                      <span>4+</span>
                      <img src={pup4} alt="" />
                      <input type="checkbox" checked={pet_count === '4' ? true : false} id="4" value="4" onChange={(e) => { this.petOnDataChange(e, 'pet_count') }} name="4" className="custom--checkbox" />
                    </label>
                  </div>

                </div>
                {is_extra_pet &&
                  <div className="row">
                    <div className="col-md-8">
                      <div className="form-group mt-3">
                        <input type="text"
                          onBlur={(e) => { if (e.target.value > 0) { this.getPriceMatrics() } }}
                          onChange={(e) => { this.setState({ 'extra_pet_count': e.target.value > 3 ? e.target.value : '' }, () => this.getPriceMatrics()) }}
                          value={extra_pet_count}
                          name="extra_pet_count" className="form--control extra_pet_count" placeholder="Please specify the exact number of dogs" />
                      </div>
                    </div>
                  </div>
                }
              </Panel>
            </Collapse>

            {errors?.pet_count ? <label className="new_err_msg"><i className="las la-info-circle"></i> {errors?.pet_count}</label> : ''}
            <Collapse
              defaultActiveKey={['3']}
              expandIconPosition="right"
              expandIcon={({ isActive }) => <img src={Path} alt="" className={isActive ? '' : 'icon_rotate'} />}
            >
              <Panel header="When was your yard last cleaned?" key="3" className="last_clean">
                <div className="option_list">
                  <div className="option_list_item mt-2">
                    <label htmlFor="less_than_2_weeks" className={last_cleaned === 'less_than_2_weeks' ? 'place_box active_place_box' : last_cleaned !== '' && last_cleaned !== 'less_than_2_weeks' ? 'place_box box_opacity' : 'place_box'}>
                      <span>Less than 2 weeks</span>
                      <p className="sub_details">It’s spotless!</p>
                      <input type="checkbox" checked={last_cleaned === 'less_than_2_weeks' ? true : false} id="less_than_2_weeks" value="less_than_2_weeks" onChange={(e) => { this.onLastCleanChange(e) }} name="less_than_2_weeks" className="custom--checkbox" />
                    </label>
                  </div>

                  <div className="option_list_item mt-2">
                    <label htmlFor="1-2_months" className={last_cleaned === '1-2_months' ? 'place_box active_place_box' : last_cleaned !== '' && last_cleaned !== '1-2_months' ? 'place_box box_opacity' : 'place_box'}>
                      <span>2 to 6 weeks</span>
                      <p className="sub_details">It’s pretty neglected</p>
                      <input type="checkbox" checked={last_cleaned === '1-2_months' ? true : false} id="1-2_months" value="1-2_months" onChange={(e) => { this.onLastCleanChange(e) }} name="1-2_months" className="custom--checkbox" />
                    </label>
                  </div>
                  <div className="option_list_item mt-2">
                    <label htmlFor="2_months_or_more" className={last_cleaned === '2_months_or_more' ? 'place_box active_place_box' : last_cleaned !== '' && last_cleaned !== '2_months_or_more' ? 'place_box box_opacity' : 'place_box'}>
                      <span>More than 6 weeks</span>
                      <p className="sub_details">Watch your step!</p>
                      <input type="checkbox" checked={last_cleaned === '2_months_or_more' ? true : false} id="2_months_or_more" value="2_months_or_more" onChange={(e) => { this.onLastCleanChange(e) }} name="2_months_or_more" className="custom--checkbox" />
                    </label>
                  </div>
                </div>
              </Panel>
            </Collapse>
            {errors?.last_cleaned ? <label className="new_err_msg"><i className="las la-info-circle"></i> {errors?.last_cleaned}</label> : ''}

          </div>
          <div className="step2">
            <h1>Customize your cleaning</h1>
            <div className="row">
              <div className="col-md-12">
                <section className="area_clean">
                  <h2>Areas to Clean <span className="required">*</span> <span>(Select one or multiple)</span></h2>
                  <p className="sub_title">1 area included in price, add ${ZipcodeCheck && ZipcodeCheck[0] && ZipcodeCheck[0]['additional_cleaning_area_price'] && ZipcodeCheck[0]['additional_cleaning_area_price']}/visit for each additional area. </p>
                  <ul className="area_clean_list">
                    {areas_to_clean.map(area => {
                      return (
                        <li key={area.display}>
                          <label htmlFor={area.display} className={area.isSelected ? 'area_box active_area_box' : 'area_box'}>
                            <input type="checkbox" checked={area.isSelected} id={area.display} value={area.isSelected} onChange={() => this.onAreaCleanChange(area)} name={area.display} className="custom--checkbox" />
                            <span>{this.getAreasToCleanText(area.display, area.isFirst, price, areas_to_clean)}</span>
                          </label>
                        </li>)
                    })}
                  </ul>
                  {areas_to_clean && areas_to_clean[OTHER_INDEX] && areas_to_clean[OTHER_INDEX].isSelected &&
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <input
                            type="text"
                            maxLength={20}
                            onBlur={(e) => {
                              if (e.target.value) {
                                this.getPriceMatrics();
                              }
                            }}
                            onChange={(e) => {
                              if (e.target.value) {
                                this.setState({ is_continue_btn_active: true });
                              } else {
                                this.setState({ is_continue_btn_active: false });
                              }
                              const newAreas = [...this.state.areas_to_clean];
                              newAreas[OTHER_INDEX].value = e.target.value;
                              this.setState({ areas_to_clean: newAreas })
                            }}
                            value={areas_to_clean[OTHER_INDEX].value}
                            name="other_value"
                            className="form--control"
                            placeholder="Please specify ‘Other’" />
                        </div>
                      </div>
                    </div>}
                </section>
                <section className="additional_services">
                  <h2>Additional Services <span>(Optional)</span></h2>
                  <ul className="option_list">
                    {this.renderAdditionalServices()}
                  </ul>
                </section>

                {!is_take_away ?
                  <section className="scoope_waste">
                    <h2>Scooped Waste Disposal Location <span>(Optional)</span></h2>
                    <p className="sub_title">Our standard policy is to double bag the scooped waste, tie it securely to contain odor, and place it in your garbage can. Please let us know where the garbage can is located or if you’d like the bagged waste placed elsewhere.</p>
                    <div className="form-group">
                      <input type="text"
                        onChange={(e) => { this.setState({ 'disposal_location': e.target.value }) }}
                        className="form--control" name="disposal_location" placeholder="Scooped Waste Disposal Location" />
                    </div>
                  </section>
                  : ''}
                <section className="cleaning_notes">
                  <h2>Cleaning Notes <span>(Optional)</span></h2>
                  <p className="sub_title">Any special instructions about your property that we should know? (e.g. gate code, which gate to use, yard access, etc.)</p>
                  <div className="form-group">
                    <textarea
                      onChange={(e) => { this.setState({ 'cleaning_notes': e.target.value }) }}
                      className="form--control" name="cleaning_notes" placeholder="Additional Cleaning Notes" />
                  </div>
                </section>
              </div>
            </div>
          </div>
          <div className="submit_btn mobile_continue_btn">
            <button type="button" onClick={(e) => { this.goToNextStep(e) }} className="btn">Continue</button>
          </div>
        </div>

        <div className="col-md-1 d-lg-block d-md-none"></div>
        <div className="col-md-5 col-lg-4">
          <Sidebar
            is_footer={this.props.is_footer}
            pricingCalculator={(e) => { this.props.pricingCalculator(e) }}
            current={this.props.current}
            onPrepayChange={this.props.onPrepayChange}
            onPrepayTypeChange={this.props.onPrepayTypeChange}
            PlaceServiceOrder={() => { }}
            prepay_months={this.props.prepay_months}
            PricingCalc={this.props.PricingCalc}
            frequency={frequency}
            is_continue_btn_active={is_continue_btn_active}
            history={this.props.history}
            ZipcodeCheck={this.props.ZipcodeCheck}
            is_prepaid={this.props.is_prepaid}
            loader={loader}
            selectedAreas={this.state.selectedArea}
            lastCleaned={this.state.last_cleaned}
            petCount={this.state.is_extra_pet ? (this.state.extra_pet_count || 4) : this.state.pet_count}
            propertyType={this.state.property_type}
            goToNextStep={() => this.goToNextStep()}
            Setp1Validation={this.Setp1Validation}
          />
        </div>
        {loader && <div className="loader_wrapper">
          <div className="loader07"></div>
        </div>}
        {/* Property Modal Popup */}
        <Modal
          className="detached_modal"
          visible={is_single_family_large}
          onCancel={() => {
            this.setState({
              property_type: '',
              is_single_family_large: false,
              is_continue_btn_active: false,
            })
            this.props.userCanProceedToCheckout(false);
          }}
          footer={[

            <Button key="submit" type="primary" onClick={() => {
              this.setState({
                property_type: 'single_family_large',
                is_single_family_large: false
              })
              this.getPriceMatrics();
            }}>
              Continue
            </Button>,
          ]}
        >
          <h4 className="modal_title">Just a heads up!</h4>
          <p className="desc">Depending on the size of the area to clean, your price may be different. We will communicate any price changes before providing service at a higher rate.</p>
        </Modal>


      </div>
    );
  }
}

export default Step1;
